module.exports = __webpack_public_path__ + "img/navbarbottom.d25d9f14.jpg";